<template>
    <div>
        <breadcrumbs class="is-hidden-mobile is-marginless"></breadcrumbs>
        <div class="columns is-marginless">
        <nav v-if="$store.state.debug" class="panel is-hidden-touch navSideBar">
            <div class="panel-heading">
                {{ activeTab? activeTab.title: 'Please Select a Tab' }}
            </div>
            <p class="panel-tabs">
                <a v-for="tab in tabs" :v-key="tab.name"
                   @click="activeTab = tab"
                   :class="{'is-active': activeTab === tab}"
                >
                    {{tab.name}}
                </a>
            </p>
            <tab ref="edar" name="Edars" title="EDAR" :active="activeTab === $refs.edar">
            <router-link class="panel-block" :to="{name: 'edar_overview'}" exact-active-class="is-active">
                Overview
            </router-link>
            <router-link v-for="(edar, index) in edars" v-bind:key="index+1000"
                         :to="{name: 'edar_detail', params: {edarId: edar.id}}"
                         class="panel-block is-flex"
                         style="justify-content: space-between;"
                         exact-active-class="is-active"
            >
                <span :class="{
                            'has-text-warning': edar.status === 'Faulted',
                            'has-text-danger': edar.status === 'Offline',
                            'has-underline': edar.status !== 'Online',
                         }">
                    {{edar.name}}
                </span>
                <router-link tag="button" class="button title is-7"
                             :to="{name: 'edar_staff_viewer', params: {edarId: edar.id}}"
                >
                    LIVE
                </router-link>
            </router-link>
            </tab>
            <tab ref="deploy" name="Deployments" title="Deployments" :active="activeTab === $refs.deploy">
                <router-link class="panel-block" :to="{name: 'deployment_overview'}" exact-active-class="is-active">
                Overview
                </router-link>
                <router-link v-for="(deployment, index) in deployments" v-bind:key="index+1000000"
                         :to="{name: 'deployment_detail', params: {deploymentId: deployment.id}}"
                         class="panel-block is-flex"
                         exact-active-class="is-active"
                >
                {{deployment.name}}
            </router-link>
            </tab>
        </nav>
            <router-view class="column"></router-view>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Tab from "../../components/tab";

    export default {
        name: "Wrapper",
        components: {Tab},
        data:() => ({
            'debugCounter': 0,
            'activeTab': null,
            'tabs': [],
        }),
        computed: {
            ...mapState('edar', [
                'edars',
            ]),
            ...mapState('deployment', [
                'deployments',
            ]),
        },
        created() {
            this.$store.dispatch('edar/startPolling');
        },
        destroyed() {
            this.$store.dispatch('edar/stopPolling');
        },
        mounted() {
            this.tabs = [
                this.$refs.edar,
                this.$refs.deploy,
            ];

            this.$route.matched.forEach( route => {
                if (route.meta && route.meta.breadcrumb) {
                    if (route.meta.breadcrumb === 'Edar') {
                        this.activeTab = this.$refs.edar;
                    }
                    if (route.meta.breadcrumb === 'Deployment') {
                        this.activeTab = this.$refs.deploy;
                    }
                }
            });
        },
        methods: {
        },
    }
</script>

<style scoped lang="scss">
.navSideBar {
    flex: none;
    width: 15rem;
    margin-top: 10em;
    margin-left: 0.5rem;
}
</style>